import { SbkElement } from '../../configuration/sbk-element.ts';
import { customElement, property } from 'lit/decorators.js';
import { style } from './icon.styles';
import { html, nothing } from 'lit';
import { when } from 'lit/directives/when.js';


@customElement('sbk-icon')
export class SbkIcon extends SbkElement {

    @property({type: String})
    symbol = '';

    @property({type: String})
    size?: '16' | '20' | '24' | '32' | '40' | '64' | '88' | '112' | '160' = '24';

    @property({type: String})
    description= '';

    @property({type: Boolean})
    responsive= false;

    static get styles() {
        return style;
    }

    render() {
        const ariaDescriptionReference = this.description ? 'icon-title' : false;
        const spriteUrl = '/icons/sprite.svg';
        return html`
            <svg part="icon"
                class="icon icon-${this.size} ${this.responsive ? 'responsive' : ''}"
                aria-describedby=${ariaDescriptionReference || nothing}
                aria-hidden=${this.description ? 'false' : 'true'}
                role="img"
            >
                ${when(this.description, () => html`<title id="icon-title">${this.description}</title>`)}
                <use href="${spriteUrl}#icon-${this.symbol}"></use>
            </svg>
        `;

    }
}
